import aboutus from './aboutus/actionCreatore' 
import partners from './partners/actionCreatore' 
import services from './services/actionCreatore' 
import settings from './settings/actionCreatore' 
import home from './home/actionCreatore' 
import contact from './contact/actionCreatore' 
import careers from './careers/actionCreatore' 
const modules = {
    aboutus,
    services,
    settings,
    contact,
    careers,
    home,
    partners
}
export default {modules}